<div class="row white rounded shadow-sm m-0 p-0">
    <div class="col-12 m-0 p-0">
        <mat-tab-group mat-stretch-tabs md-no-pagination="true">
            <mat-tab label="Cobertura" class="p-0">
                <div class="row my-5 px-md-4 mx-0">
                    <div class="col-12 p-0 col-md-6 col-lg-4">
                        <img src="../../../assets/img/familia-pasando-tiempo-frente-television.png" class="w-100" alt="">
                    </div>
                    <div class="col-12 col-md-6 ps-md-5 col-lg-8 d-flex mt-3 mt-md-0">
                        <ul class="d-flex flex-column justify-content-center">
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL1' | translate }} </li>
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL2' | translate }} </li>
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL3' | translate }} </li>
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL4' | translate }} </li>
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL5' | translate }} </li>
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL6' | translate }} </li>
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL7' | translate }} </li>
                        </ul>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Qué no cubre +Garantía">
                <div class="row my-5 ps-md-4 mx-0">
                    <div class="col-12 col-lg-4">
                        <img src="../../../assets/img/tab2.png" alt="">
                    </div>
                    <div class="col-12 col-lg-8 ps-md-5 d-flex">
                        <ul class="d-flex flex-column justify-content-center">
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL8' | translate }} </li>
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL9' | translate }} </li>
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL10' | translate }} </li>
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL11' | translate }} </li>
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL12' | translate }} </li>
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL13' | translate }} </li>
                            <li class="my-2"> {{ 'WARRANTY_COVERAGE.LABEL14' | translate }} </li>
                        </ul>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="Artículos elegibles">
                <div class="row justify-content-center m-0 p-0">
                    <div class="col-12 col-md-10 py-5 m-0 p-0">
                        <ng-container *ngFor="let item of items">                        
                            <mat-accordion>
                                <mat-expansion-panel>
                                  <mat-expansion-panel-header>
                                    <mat-panel-title>
                                      <b>
                                        {{ item.Question }}
                                      </b>
                                    </mat-panel-title>
                                  </mat-expansion-panel-header>
                                
                                  <p class="p-0 m-0">{{ item.Answer }}</p>
                                </mat-expansion-panel>
                                
                            </mat-accordion>
                        </ng-container>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>